import { render } from "./SelectLanguage.vue?vue&type=template&id=b7b3e82c&scoped=true&ts=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=ts"
export * from "./SelectLanguage.vue?vue&type=script&lang=ts"

import "./SelectLanguage.vue?vue&type=style&index=0&id=b7b3e82c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./SelectLanguage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "D:\\deul\\dev\\heselCare\\hesel-care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b3e82c"]])

export default __exports__